// extracted by css-extract-rspack-plugin
export default {"header":"PromoCodesTitle-module__header--Urw7V"};